class firm {
    constructor(
      active,
      nameProcedure,
      description,
      order

      ) {
      this.active = active === true ? '✔️' : "";
      this.activeTable = active;
      this.nameProcedure = nameProcedure;
      this.description = description;
      this.order = order;
    }
    static fromJson({
        activa,
        nomProc,
        descrip,
        orden
    }) {
      return new firm(
        activa,
        nomProc,
        descrip,
        orden
      );
    }
  }
  export default firm;
  